import axios from 'axios'
import store from '../store'
import router from '../router'

// Request interceptor
axios.interceptors.request.use(
  config => {
    const token = store.state.auth.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    // Nếu lỗi 401 và chưa thử refresh token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // Thử refresh token
        const newToken = await store.dispatch('auth/refreshToken')
        if (newToken) {
          // Cập nhật token trong header của request gốc
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`
          // Thử lại request gốc
          return axios(originalRequest)
        }
      } catch (refreshError) {
        // Nếu refresh token thất bại, logout và chuyển đến trang đăng nhập
        await store.dispatch('auth/logout')
        router.push('/login')
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default axios